import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getEmailToMailCompany = async (params) => {
    return await api.post("/v1/emailNotification/getEmailToMailCompany", params);
};
export const updateStatusEmailToMailCompany = async (params) => {
    return await api.post("/v1/emailNotification/updateStatusEmailToMailCompany", params);
};
export const addEmailToMailCompany = async (params) => {
    return await api.post("/v1/emailNotification/addEmailToMailCompany", params);
};
export const updateEmailToMailCompany = async (params) => {
    return await api.post("/v1/emailNotification/updateEmailToMailCompany", params);
};
export const deleteEmailToMailCompany = async (params) => {
    return await api.post("/v1/emailNotification/deleteEmailToMailCompany", params);
};

export const getDepartmentOptions = async (params = {}) => {
    return await api.post("/v1/dropdown/getStmDepartment", params);
};

export const getPosition = async (params = {}) => {
    return await api.post("/v1/position/getPosition", params);
};

export const getBranch = async (params = {}) => {
    return await api.post("/v1/dropdown/getBranch", params);
};

export const getShiftOptions = async (params = {}) => {
    return await api.post("/v1/dropdown/getShiftsByCompannyId", params);
};